import { useState, useMemo } from 'react';

const getVal = (obj, key) =>
  key.split('.').reduce((acc, k) => acc?.[k], obj) ?? '';

const useSortTable = (rows = []) => {
  const [sortBy, setSortBy] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const handleSort = (key) => {
    if (sortBy === key) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(key);
      setSortDir('asc');
    }
  };

  const sorted = useMemo(() => {
    if (!sortBy) return rows;
    return [...rows].sort((a, b) => {
      const av = getVal(a, sortBy);
      const bv = getVal(b, sortBy);
      const cmp = String(av).localeCompare(String(bv), 'es', { numeric: true, sensitivity: 'base' });
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }, [rows, sortBy, sortDir]);

  return { sorted, sortBy, sortDir, handleSort };
};

export default useSortTable;
